import type { ApplicantManager } from "@sr-partner-portal/common";
import { createContext, useContext } from "react";

interface ApplicantManagerContext {
    applicantManager: ApplicantManager;
    setApplicantManager: (applicantManager: ApplicantManager) => void;
}

export const ApplicantManagerContext = createContext<ApplicantManagerContext>({
    applicantManager: null,
    setApplicantManager: () => undefined,
});
export const ApplicantManagerProvider = ApplicantManagerContext.Provider;
export const useApplicantManagerContext = () =>
    useContext(ApplicantManagerContext);
